import axios from 'axios';

const apiBaseUrl = (process.env.REACT_APP_API_URL || 'https://apidream.synergyindustri.com/api/').replace(/\/$/, '') + '/';

const api = axios.create({
    baseURL: apiBaseUrl,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to attach auth token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Token ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor to handle unauthorized errors
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            clearSession();
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export const clearSession = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('role');
};

export const saveSession = ({ token, user }) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('role', user?.role || 'employee');
};

/** The signed-in user as stored at login, or null. */
export const getUser = () => {
    try {
        const raw = localStorage.getItem('user');
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

export const getRole = () => getUser()?.role || localStorage.getItem('role') || null;

/** Pull a readable message out of a DRF error response. */
export const errorMessage = (error, fallback = 'Something went wrong.') => {
    const data = error?.response?.data;
    if (!data) return error?.message || fallback;
    if (typeof data === 'string') return data;
    if (data.error) return data.error;
    if (data.detail) return data.detail;
    const first = Object.entries(data)[0];
    if (!first) return fallback;
    const [field, value] = first;
    const text = Array.isArray(value) ? value[0] : value;
    return `${field}: ${text}`;
};

/** Download a report export as a file without leaving the page. */
export const downloadExport = async (params, filename) => {
    const response = await api.get('reports/export/', {
        params,
        responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

export default api;
